import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Analytics"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 1.5H1.5V21C1.5 21.8284 2.17157 22.5 3 22.5H22.5V21H3V1.5ZM22.5 6.75H17.25V8.25H19.9425L14.25 13.9425L11.0325 10.7175C10.8917 10.5755 10.7 10.4957 10.5 10.4957C10.3 10.4957 10.1083 10.5755 9.9675 10.7175L4.5 16.1925L5.5575 17.25L10.5 12.3075L13.7175 15.5325C13.8583 15.6745 14.05 15.7543 14.25 15.7543C14.45 15.7543 14.6417 15.6745 14.7825 15.5325L21 9.3075V12H22.5V6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Analytics.vue"]]);
